import PropTypes from 'prop-types';
import { Component } from 'react';

import { isDev } from 'lib/utils';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  async componentDidCatch(error, info) {
    if (isDev()) {
      // eslint-disable-next-line no-console
      console.error(info.componentStack);
      return;
    }

    const { captureException } = await import('@sentry/nextjs');

    captureException(error, { contexts: { react: info.componentStack } });
  }

  render() {
    const { fallback: Fallback, children } = this.props;

    if (this.state.hasError) {
      if (!Fallback) return null;

      if (typeof Fallback === 'function') return <Fallback />;
      return Fallback;
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]),
};

export default ErrorBoundary;
